// Helper to safely access import.meta.env
const getEnv = (key: string) => {
    try {
        // @ts-ignore
        if (typeof import.meta !== "undefined" && import.meta.env) {
            // @ts-ignore
            return import.meta.env[key];
        }
    } catch (e) {
        // Fallback for environments where import.meta is a syntax error
    }
    return process.env[key];
};

export const env = {
    VITE_ENCRYPTION_SECRET: getEnv("VITE_ENCRYPTION_SECRET") || "",
    VITE_ENCRYPTION_IV: getEnv("VITE_ENCRYPTION_IV") || "",
    VITE_API_BASE_URL: getEnv("VITE_API_BASE_URL") || "",
};

